

























export default
  data: () ->
    showMenu: false

  props:
    isPartner:
      type: Boolean
      default: false
    level:
      type: Number
      default: 0

  methods: {
    humbarger_click: (e) ->
      @showMenu = !@showMenu
  }
